"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseFigmaFileKey = parseFigmaFileKey;
exports.figmaLinkKind = figmaLinkKind;
exports.clampFigmaScale = clampFigmaScale;
/**
 * A Figma file or design URL, reduced to its file key.
 *
 * Figma has NO "list the teams I belong to" endpoint, so a picker cannot browse from nothing —
 * the user pastes a URL and we work from that. Accepts the current `/design/<key>/…` form, the
 * older `/file/<key>/…`, and FigJam's `/board/<key>/…`.
 *
 * Buzz (`/buzz/`) and Slides (`/slides/`) links return null ON PURPOSE: Figma's Files API serves
 * only Design and FigJam files and answers 400 "File type not supported by this endpoint" for the
 * rest. `figmaLinkKind` says which product a refused link was, so the refusal can be honest.
 */
function parseFigmaFileKey(url) {
    const match = /figma\.com\/(?:design|file|board)\/([A-Za-z0-9]{10,})/.exec(url.trim());
    return match ? match[1] : null;
}
/**
 * Classify a pasted Figma link by its product segment. null = not a figma.com file link at all.
 *
 * The 10+ character key is required here too, so a marketing page such as `figma.com/buzz/` is
 * "not a file link" rather than a Buzz file.
 */
function figmaLinkKind(url) {
    const m = /figma\.com\/([a-z]+)\/[A-Za-z0-9]{10,}/i.exec(url.trim());
    if (!m)
        return null;
    const seg = m[1].toLowerCase();
    if (seg === 'design' || seg === 'file')
        return 'design';
    if (seg === 'board')
        return 'board';
    if (seg === 'buzz')
        return 'buzz';
    if (seg === 'slides')
        return 'slides';
    return 'other'; // make, site, proto ...
}
/** Clamp a Figma render scale into the range the API accepts. */
function clampFigmaScale(scale) {
    if (scale == null || !Number.isFinite(scale))
        return 2;
    return Math.min(4, Math.max(1, Math.round(scale)));
}
//# sourceMappingURL=design-tools.js.map